import { connectStats } from 'instantsearch.js/es/connectors';
// Create the render function
const renderStats = (renderOptions, isFirstRender) => {
    const { nbHits, processingTimeMS, query, widgetParams } = renderOptions;
  
    widgetParams.container.innerHTML=`<p> ${ widgetParams.templates.text} </p>`;
    
if(nbHits <= 0 || !query){
   widgetParams.container.style.display="block";
}else{
    widgetParams.container.style.display="none";
}
};

  // Create the custom widget
  const customStats = connectStats(renderStats);
  export default customStats;